import { defineStore } from 'pinia'
import { useI18n } from 'vue-i18n'

/**
 * Overlay panel state + content fetch.
 */
export const useOverlayStore = defineStore('overlay', () => {
  const cacheStore = useCacheStore()
  const cmsFetch = useCmsFetch()
  const { locale } = useI18n()

  const isOpen = ref(false)
  const isDismissed = ref(false)

  function openPanel() {
    if (!isDismissed.value) {
      isOpen.value = true
    }
  }
  function hidePanel() {
    isOpen.value = false
  }
  function dismissPanel() {
    isOpen.value = false
    isDismissed.value = true
  }

  async function fetchOverlay() {
    const key = `overlay;overlayContent;locale:${locale.value}`
    const ttl = 1
    const fetcher = async () => await cmsFetch(`/api/${locale.value}/overlay.json`)

    return await cacheStore.fetch({ key, ttl, fetcher })
  }

  return { isOpen, isDismissed, openPanel, hidePanel, dismissPanel, fetchOverlay }
})
